import { FaShip, FaMapMarkerAlt } from "react-icons/fa";
import { TbCapture, TbRadar2 } from "react-icons/tb";
import {
  FaPen,
  FaVideo,
  FaRoute,
  FaWater,
  FaStar,
  FaDroplet,
} from "react-icons/fa6";
import { HiSignal } from "react-icons/hi2";
import {
  MdOutlineVideoChat,
  MdEditNote,
  MdOutlineNavigation,
} from "react-icons/md";
import { PiFrameCorners, PiEyedropperSampleFill } from "react-icons/pi";
import { GrBeacon } from "react-icons/gr";
import { PiFlagCheckeredFill } from "react-icons/pi";
import { FaExclamationTriangle, FaMapMarkedAlt } from "react-icons/fa";
import { GiMiniSubmarine } from "react-icons/gi";

const normalizeEventValue = (value: string) => {
  return value
    .toUpperCase()
    .replace(/[_\s-]/g, " ")
    .trim();
};

export const getIconForSealogEventValue = (eventValue: string, iconClass: string) => {
  const normalizedValue = normalizeEventValue(eventValue);

  switch (normalizedValue) {
    case "VEHICLE":
      return <FaShip className={iconClass} />;
    case "ASNAP":
      return <TbCapture className={iconClass} />;
    case "FREE FORM":
      return <FaPen className={iconClass} />;
    case "FILMING":
      return <FaVideo className={iconClass} />;
    case "VIDEOLOGGER":
      return <MdOutlineVideoChat className={iconClass} />;
    case "FRAMEGRAB":
      return <PiFrameCorners className={iconClass} />;
    case "OBSERVATION":
      return <MdEditNote className={iconClass} />;
    case "SAMPLE":
      return <PiEyedropperSampleFill className={iconClass} />;
    case "START TRANSECT":
      return <MdOutlineNavigation className={iconClass} />;
    case "END TRANSECT":
      return <PiFlagCheckeredFill className={iconClass} />;
    case "BEACON TRACKING":
      return <GrBeacon className={iconClass} />;
    case "DISTANCE TRAVELLED":
      return <FaRoute className={iconClass} />;
    case "PROFILER":
      return <FaWater className={iconClass} />;
    case "PROBLEM":
      return <FaExclamationTriangle className={iconClass} />;
    case "SPECIAL OPS":
      return <FaStar className={iconClass} />;
    case "SURVEY":
      return <TbRadar2 className={iconClass} />;
    case "MAP":
      return <FaMapMarkedAlt className={iconClass} />;
    case "SUB":
      return <GiMiniSubmarine className={iconClass} />;
    case "SUBMERSIBLE":
      return <GiMiniSubmarine className={iconClass} />;
    case "SUB SIGHTING":
      return <GiMiniSubmarine className={iconClass} />;
    case "WAYPOINT":
      return <FaMapMarkerAlt className={iconClass} />;
    case "HYDROPHONE":
      return <HiSignal className={iconClass} />;
    default:
      return <FaDroplet className={iconClass} />;
  }
};
